// "← Back to report" - the state a Reports drill-down needs to come home to.
//
// A Reports row opens the Leads page, which unmounts the report and its local
// period/filter state. The drill-down spec carries a `back` descriptor; the Back
// chip calls saveReportReturn(back) and navigates to Reports, and the report's
// component reads it ONCE on mount (peek in its state initializers, clear after) -
// the same read-once / navigate / clear shape as the deep-link landers, no browser
// history involved. The tab / sub-view / view-mode are written through the keys
// those pickers already persist, so the existing initializers restore them untouched.
//
// Nothing is written at drill time: a stale entry can never hijack a later, ordinary
// visit to Reports (and an entry older than ten minutes is ignored regardless).
//
// The TAB goes through the shared tab memory as a one-shot request (2026-10-28):
// it beats the remembered tab on the next mount of Reports and is consumed there.
import { requestTab } from "./tabMemory";
var KEY = "crm_report_return";
var MAX_AGE_MS = 10 * 60 * 1000;

export function saveReportReturn(back) {
  if (!back) return;
  try {
    localStorage.setItem(KEY, JSON.stringify({ at: Date.now(), back: back }));
    if (back.tab) requestTab("reports", back.tab);
    if (back.view) localStorage.setItem("crm_reports_campaigns_view", back.view);
    if (back.mode) localStorage.setItem("crm_reports_campaign_perf_mode", back.mode);
  } catch (e) { /* storage blocked: the report simply opens at its defaults */ }
}

// The restored component state for `kind`, or null (nothing stored, another report's, stale).
export function peekReportReturn(kind) {
  try {
    var v = JSON.parse(localStorage.getItem(KEY) || "null");
    if (!v || !v.back || v.back.kind !== kind) return null;
    if (Date.now() - v.at > MAX_AGE_MS) return null;
    return v.back.state || null;
  } catch (e) { return null; }
}

export function clearReportReturn() {
  try { localStorage.removeItem(KEY); } catch (e) {}
}
